import React from 'react'
import { result } from 'libraries/lodash'
import cx from 'classnames'
import Clear from '@material-ui/icons/Clear'
import withStyles from '@material-ui/core/styles/withStyles'
import MuiIconButton from '@material-ui/core/IconButton'
import { DOCUMENTS_CONTENT, PRECEDENTS_CONTENT, QA_MENU } from 'constants/controllers'
import { useSelector } from 'react-redux'
import selectQaSectionsMap from 'redux/selectors/selectQASectionsMap'
import selectQaNodeMap from 'redux/selectors/selectQANodeMap'

const IconButton = withStyles({
  root: { padding: 6 }
})(MuiIconButton)

const TileInfoPopoverContent = ({ title, getUrl, sectionId, controller, nodes, remove, cxNames, contentOverride }) => {
  const { borderColor, backgroundColor } = cxNames.popover
  return (
    <div
      style={{ width: 260 }}
      className={cx('relative bt-xl', borderColor, backgroundColor)}
    >
      <div className='absolute top2 right2' onClick={remove}>
        <IconButton>
          <Clear className='hover-black' />
        </IconButton>
      </div>
      <h4 className='ml6 mr9 mt5'>{title}</h4>
      {contentOverride || <Content {...{ controller, nodes, sectionId, getUrl }} />}
      {!contentOverride && (
        <PopoverButton
          backgroundColor={cxNames.popover.buttonColor}
          getUrl={getUrl}
          sectionId={sectionId}
        />
      )}
    </div>
  )
}

const Content = ({ controller, nodes, sectionId, getUrl }) => {
  switch (controller) {
    case PRECEDENTS_CONTENT:
    case DOCUMENTS_CONTENT:
      return <PrecedentsContent {...{ nodes, sectionId, getUrl }} />
    case QA_MENU:
      return <QaContent {...{ getUrl, sectionId }} />
    default:
      return null
  }
}

const QaContent = ({ getUrl, sectionId }) => {
  const qaSectionsMap = useSelector(selectQaSectionsMap)
  const qaNodeMap = useSelector(selectQaNodeMap)
  const section = qaSectionsMap.get(sectionId)
  const childSections = section.childSections
  const childNodes = childSections.map(id => qaNodeMap.get(id))

  return (
    <ul className='list-reset pa0 ml6 mt0'>
      {childNodes.filter(node => node.active).map(({ id, title }) => (
        <li key={id} className='lh-solid mb5'>
          <a
            className='no-underline hover-underline dim-grey'
            href={getUrl({ sectionId, expanded: id, focusedId: id })}
          >
            {title}
          </a>
        </li>
      ))}
    </ul>
  )
}

const PrecedentsContent = ({ nodes, sectionId, getUrl }) => (
  <ul className='list-reset pa0 ml6 mt0'>
    {result(nodes, [sectionId, 'childSections'], []).map(id => (
      <li key={id} className='lh-solid mb5' data-testid='precedent-tile-popover-list-item'>
        <a
          className='no-underline hover-underline dim-grey'
          href={getUrl({ sectionId, expanded: id, focusedId: id })}
        >
          {nodes[id].title}
        </a>
      </li>
    ))}
  </ul>
)

const PopoverButton = ({ backgroundColor, getUrl, sectionId }) => (
  <div className='w-100 pa6 flex justify-center hover-o-80'>
    <a
      className={cx('tc no-underline w-100 pa3 ma0 maauto white hover-white', backgroundColor)}
      href={getUrl({ sectionId })}
    >
      Open chapter
    </a>
  </div>
)

export default TileInfoPopoverContent
